import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { useUI } from './composables'

// Import global styles
import '../public/css/color-system.css'

const app = createApp(App)

// For backward compatibility, provide UI utilities
app.provide('showLoading', (msg: string) => store.dispatch('ui/showLoading', msg))
app.provide('hideLoading', () => store.dispatch('ui/hideLoading'))
app.provide(
  'showToast',
  (type: string, title: string, message: string, duration?: number) =>
    store.dispatch('ui/showToast', { type, title, message, duration })
)

app.use(store).use(router).mount('#app')
